export default __webpack_public_path__ + "static/media/UndercurrentBTN.b11b36c1.woff";